import {useEffect} from 'react';

export function useEditorPrefetchTextMobileModules(): void {
  useEffect((): void => {
    void prefetchTextAndTextSlideModules();
  }, []);

  const prefetchTextAndTextSlideModules = async (): Promise<void> => {
    // text, text slide
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-size-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-style-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-line-height-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-letter-spacing-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-item-font-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-list-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-spellcheck-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-alignment-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-shadow-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-fill-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-background-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-outline-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-slides-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-add-slide-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-transition-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-apply-properties-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-edit-text-panel');
  };
}
